<div class="game-tournament-container">
    <!-- <div class="tournamentContainer" fxLayout="row" fxLayoutAlign="center center">
        <h2 fxLayoutAlign="center center" class="tournament-title" i18n><img class="tournament-icon" src="assets/mobile/icon-category-tournament-32x32.svg" alt="icon-category-tournament">Lemon Tournaments</h2>
        <span class="spacer"></span>
        <a class="button-all-games" mat-button color="primary" [routerLink]="['/', tournamentsTrx]" i18n>See All</a>
        <div class="swiper-navigation">
            <img src="{{licenceService.getKey('icon-right')}}" alt="arrow" icon-btn direction="left" (click)="prev()">
            <img src="{{licenceService.getKey('icon-right')}}" alt="arrow" icon-btn class="button-next" (click)="next()">
        </div>

    </div>
    <div class="card-wrapper">
        <swiper fxFlex="auto" [config]="config" #swiper>
            <ng-template swiperSlide *ngFor="let item of tournments; let index=index">
                <app-home-page-tournament-card [routeURL]="tournamentsTrx" [tournament]="item" [isEmbedded]="false" [tournamentIndex]="index"></app-home-page-tournament-card>
            </ng-template>
        </swiper>

        
    </div> -->

    <ng-container *ngIf="tournments">
        <app-swiper 
          [swiperHead]="headTemplate" 
          [swiperBody]="bodyTemplate" 
          [swiperConfig]="swiperConfig"
        > 

          <ng-template #headTemplate>
            <app-swiper-game-categories-head #head [displayName]="tournamentTitle" [iconUrl]="'assets/playbison/icon-tournaments.png'" [link]="tournamentsTrx"/>
          </ng-template>
      
          <ng-template #bodyTemplate>
            <ng-container  *ngFor="let item of tournments; let index=index">
                <app-home-page-tournament-card #slide style="width: max-content;" [routeURL]="tournamentsTrx" [tournament]="item" [isEmbedded]="false" [tournamentIndex]="index"/>
            </ng-container>
          </ng-template>

        </app-swiper>
    </ng-container>
</div>